export {} from './illustrations';

export {} from './messages';

export {} from './testIds';

export {} from './ShortcutTile';

export {} from './Placeholder';

export {} from './personalizationSections';

export {} from './PersonalizationModal';

export {} from './PersonalizationButton';

import ShortcutsWidget from './ShortcutsWidget';
export default ShortcutsWidget;
